import React from "react";
import { makeStyles } from "@material-ui/core";
import * as FIBER from "@react-three/fiber";
import { Canvas } from "@react-three/fiber";
import { useSelector, Provider } from "react-redux";
import { useMobile } from "../../helperFunctions";
import { store } from "../../index";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignSelf: "flex-end",
    height: 150,
    width: 150
  }
}));

function Box() {
  const scale = 0.5;
  return (
    <mesh>
      <meshStandardMaterial attach="material" color="#C51344" />
      <boxBufferGeometry attach="geometry" args={[scale, scale, scale]} />
    </mesh>
  );
}

function Axis(props) {
  const { arrow, arrowColor } = props;
  return (
    <group {...props}>
      <mesh>
        <meshStandardMaterial attach="material" color={arrowColor} />
        <cylinderBufferGeometry attach="geometry" args={[0.1, 0.1, 1.5, 16]} />
      </mesh>
      <mesh position={arrow}>
        <meshStandardMaterial attach="material" color={arrowColor} />
        <coneBufferGeometry attach="geometry" args={[0.2, 0.375, 16]} />
      </mesh>
    </group>
  );
}

function CameraControls() {
  const { camera } = FIBER.useThree();
  const rotation = useSelector((state) => state.cameraRotation);
  const position = React.useMemo(() => {
    const radius = 3.75;
    const rotY = -rotation[0];
    const rotX = -rotation[1] + (Math.PI / 180) * 90;
    const y = radius * Math.sin(rotX) * Math.sin(rotY);
    const z = radius * Math.sin(rotX) * Math.cos(rotY);
    const x = radius * Math.cos(rotX);
    return [x, y, z];
  }, [rotation]);
  camera.position.set(...position);
  camera.lookAt(0, 0, 0);
  return null;
}

export function PositionAxes() {
  const classes = useStyles();
  const mobile = useMobile();
  return (
    <div className={classes.container} style={{ marginBottom: mobile ? "35px" : "0px" }}>
      <Canvas>
        <Axis
          position={[0, 0, 0.75]}
          rotation={[(Math.PI / 180) * 90, 0, 0]}
          arrow={[0, 0.9, 0]}
          arrowColor="#C51344"
        />
        <Axis
          position={[0, 0.75, 0]}
          rotation={[0, (Math.PI / 180) * 90, 0]}
          arrow={[0, 0.9, 0]}
          arrowColor="#C51344"
        />
        <Axis
          position={[0.75, 0, 0]}
          rotation={[0, 0, -(Math.PI / 180) * 90]}
          arrow={[0, 0.9, 0]}
          arrowColor="#C51344"
        />
        <Box />
        <pointLight position={[5, 5, 5]} />
        <ambientLight intensity={0.5} />
        <Provider store={store}>
          <CameraControls />
        </Provider>
      </Canvas>
    </div>
  );
}
